<template>
  <div class="message_detail">
    <div class="inner">
      <div class="btn">
        <el-button type="primary" @click="edit">{{ $t("修改") }}</el-button>
      </div>
      <div class="title" v-if="detail.article">{{ detail.article.title }}</div>
      <div class="time" v-if="detail.article">
        {{ $formatTime(detail.modify_at, "yearMonthDay") }}
      </div>
      <div
        class="content"
        v-if="detail.article"
        v-html="detail.article.content"
      ></div>
    </div>
  </div>
</template>
<script>
// import { mapState } from "vuex";
import { getQuestionDetail } from "@/api/serve";
export default {
  name: "MessageDetail",
  data() {
    return {
      detail: {},
      content: "",
      showError: false,
      commentsList: [],
      total: 0,
    };
  },
  mounted() {
    this.$store.dispatch("getUser");
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    repeater(page) {
      this.page = page;
      this.getCommentsList();
    },
    async getDetail() {
      const res = await getQuestionDetail({ id: this.$route.query.id });
      this.detail = res.data;
    },
    edit() {
      this.$router.push(`/question?id=${this.$route.query.id}`);
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      let _this = this;
      var formData = new FormData();
      formData.append("file", file);
      fetch(this.$baseUrl + "/1/communities/upload/", {
        method: "POST",
        body: formData,
      })
        .then((data) => {
          return data.json();
        })
        .then((ret) => {
          if (ret.url) {
            let url = ret.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          } else if (ret.detail)
            _this.$message({
              message: ret.detail,
              type: "success",
              offset: "100",
            });
          else
            _this.$message({
              message: _this.$t("上載失敗"),
              type: "error",
              offset: "100",
            });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.message_detail {
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  .inner {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 40px 0;
    min-height: 80vh;
    text-align: left;
    .btn {
      display: flex;
      justify-content: flex-end;
    }
    .title {
      font-size: 28px;
      color: #676a6d;
      text-align: center;
      margin-bottom: 24px;
    }
    .time {
      color: #a8adb3;
      font-size: 16px;
      text-align: center;
      margin-bottom: 40px;
    }
    .head {
      color: #c6a86c;
      font-size: 20px;
      text-align: left;
    }
    .content {
      font-size: 14px;
      color: #676a6d;
      line-height: 2;
      text-align: left;
      white-space: pre-wrap;
      text-indent: 2em;
      margin-bottom: 40px;
    }
  }
}
</style>
